module.exports = __webpack_public_path__ + "static/img/14000382.13829ab5.png";